import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=375d222e&scoped=true"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"
import style0 from "./Pie.vue?vue&type=style&index=0&id=375d222e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d222e",
  null
  
)

export default component.exports